<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">For Mom and Uncle John, who shared a fiercely loyal bond to each other; and to our fiercely loyal and loving spouses, Daryl Johnson and<br/>
Jeffrey Ettinger.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?02d32392